<template>
  <div class="min-h-full w-full bg-transparent">
    <div class="px-6 pt-6 lg:px-8">
      <div class="overflow-hidden rounded-2xl border border-blue-100 bg-gradient-to-br from-white via-white to-blue-50 px-5 py-5 shadow-sm sm:px-6">
        <div class="flex items-start gap-4">
          <div class="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-[#2D8CFF] text-white shadow-lg shadow-blue-200/70">
            <BanknotesIcon class="h-6 w-6" />
          </div>
          <div>
            <p class="text-xs font-semibold uppercase tracking-[0.18em] text-[#2D8CFF]">Revenue center</p>
            <h2 class="mt-1 text-2xl font-semibold text-zinc-900">Payments</h2>
            <p class="mt-1 max-w-2xl text-sm leading-6 text-zinc-600">
              Track member payments, upcoming renewals, and payout history in one place.
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="mt-5 border-b border-zinc-200 bg-white/80">
      <nav
        class="app-scroll flex gap-7 overflow-x-auto px-6 lg:px-8"
        aria-label="Tabs"
      >
        <router-link
          v-for="tab in tabs"
          :key="tab.name"
          :to="tab.to"
          class="whitespace-nowrap border-b-2 px-1 py-4 text-sm font-semibold transition-colors"
          :class="tab.current
            ? 'border-[#2D8CFF] text-[#2D8CFF]'
            : 'border-transparent text-zinc-500 hover:text-zinc-700 hover:border-zinc-300'"
          @click="setActiveTab(tab.name)"
        >
          {{ tab.name }}
        </router-link>
      </nav>
    </div>

    <div class="p-6 lg:px-8 lg:pb-10">
      <router-view />
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import { BanknotesIcon } from '@heroicons/vue/24/outline';

const route = useRoute();
const tabs = ref([
  { name: 'Overview', to: '/creator/payments/overview', current: false },
  { name: 'Payments Received', to: '/creator/payments/payments-received', current: false },
  { name: 'Upcoming Renewals', to: '/creator/payments/upcoming-renewals', current: false },
  { name: 'Payouts', to: '/creator/payments/payouts', current: false },
  { name: 'Bank Accounts', to: '/creator/payments/bank-accounts', current: false },
]);

const updateActiveTab = () => {
  const currentPath = String(route.path || '');
  tabs.value.forEach((tab) => {
    tab.current = currentPath === tab.to;
  });
};

const setActiveTab = (name) => {
  tabs.value.forEach((tab) => {
    tab.current = tab.name === name;
  });
};

watch(route, updateActiveTab, { immediate: true });
</script>

<style scoped>
.app-scroll {
  scrollbar-width: thin;
  scrollbar-color: rgba(113, 113, 122, 0.34) transparent;
}

.app-scroll::-webkit-scrollbar {
  height: 6px;
}

.app-scroll::-webkit-scrollbar-track {
  background: transparent;
}

.app-scroll::-webkit-scrollbar-thumb {
  border-radius: 999px;
  background: rgba(113, 113, 122, 0.3);
}
</style>
